export default "__VITE_ASSET__DOlZdhCA__"